import { ButtonType, useModal } from '@ampol/design-system';
import { ButtonColor, ButtonVariant } from '@ampol/design-system/lib';
import { useDispatch } from 'react-redux';
import CardModalIcon from '../CardModalIcon';
import { CardDetails } from 'containers/cards/cards';
import {
  decrementMultiEditIndex,
  resetMultiEdit,
  setCurrentMultiEditIndex,
  setMultiEditSelectedCards,
  setMultiEditStatus,
  useMutliEditDefaultValuesEffect,
  useSelectCurrentCardDetail,
  useSelectMultiEditCardsLength,
  useSelectMutliEditCardIndex,
} from './MutliEditCardFormSlice';
import MultiEditCardModalContent from './MultiEditCardModalContent';
import { useSelectCardDetailsLoading } from 'selectors/selectors';

export const MULTI_EDIT_CARD_MODAL_FORM_ID = 'multi-edit-card-modal-form';
/**
 * Fully encapsulated hook for sequencing through multiple cards for editing
 * Just call open() with the selected cards to start the process
 */
export default function useMultiEditCardModal() {
  const dispatch = useDispatch();
  const currentCardDetail = useSelectCurrentCardDetail();
  const index = useSelectMutliEditCardIndex();
  const totalCards = useSelectMultiEditCardsLength();
  const isLoadingDetails = useSelectCardDetailsLoading();

  useMutliEditDefaultValuesEffect();

  function onBackSubmit() {
    const isFirstCard = index === 0;
    if (isFirstCard) {
      multiEditCardModal.close();
    } else dispatch(decrementMultiEditIndex());
  }

  const multiEditCardModal = useModal({
    id: 'multi-edit-card-modal',
    formId: MULTI_EDIT_CARD_MODAL_FORM_ID,
    color: ButtonColor.Blue,
    subtitle: currentCardDetail?.cardNumber ?? '',
    title: `Edit Card ${index + 1} of ${totalCards}`,
    variant: 'triple',
    onClose: () => dispatch(resetMultiEdit()),
    content: <MultiEditCardModalContent />,
    actions: [
      {
        label: 'Continue',
        type: ButtonType.Submit,
        inactive: isLoadingDetails,
        variant: ButtonVariant.Primary,
      },
      {
        label: 'Back',
        variant: ButtonVariant.Secondary,
        inactive: isLoadingDetails,
        onClick: () => onBackSubmit(),
      },
    ],
    icon: <CardModalIcon />,
  });

  function open(selectedCards?: CardDetails[], status?: string) {
    if (selectedCards.length <= 0) return;
    dispatch(setMultiEditSelectedCards(selectedCards));
    dispatch(setCurrentMultiEditIndex(0));
    dispatch(setMultiEditStatus(status));

    multiEditCardModal.open();
  }

  return {
    open,
  };
}
